import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import SelectPeriod from '../../../Components/shared/SelectPeriod';
import SelectUser from '../../../Components/shared/SelectUser';
import { PeriodeDashboard } from '../../../data/Interfaces';
import { filtreListPeriode } from '../DashbordBackOffice';
import { sourceMission } from './StatutMissionExpert';

function StatutCandidatures({statusCandiaturesByCompanyId,filtreClient,width,height}){

    StatutCandidatures.propTypes = {
        statusCandiaturesByCompanyId: PropTypes.any,
        filtreClient: PropTypes.any,
        width:PropTypes.any,
        height:PropTypes.any,
    };

    const [selectedPeriod3, setSelectedPeriod3] = useState('thisMonth'); // Default selected period
    const [customDateRange3, setCustomDateRange3] = useState({});
    const [selectedClient3,setSelectedClient3] = useState('all');// Default selected client
    const [filtreSourceMission, setFiltreSourceMission] = useState(['all']);
    const { i18n } = useTranslation();
    const [chartDataStatusCandidature, setChartDataStatusCandidature] = useState(
        {
            series: [],
            chart: {
                height: 350,
                type: 'pie',
                stacked: true,
                toolbar: {
                    show: true
                }
            },

            options:{
                labels:[],
                colors: ['#EFAF41', '#EC5B56','#5CC889','#FBE052','#EFAF41','#214DCE','#228b22'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }],
                plotOptions: {
                    pie: {
                        startAngle: 0,
                        endAngle: 360,
                    }
                },
                stroke: {
                    show: true,
                    width: 0, // Set the stroke width to 0 to eliminate the gap between slices
                },
            }
        });

    const calculateCounts = (data) => {
        console.log('data count candidatures',data);
        const counts= {
            analyzed_count: 0,
            interesting_count: 0,
            interview_count: 0,
            rejected_count: 0,
            retained_count: 0,
            unread_count: 0,
            converted_Count:0,
        };
        data.forEach((item) => {
            const {status } = item;

            switch (status) {
            case 'unread':
                counts.unread_count++;
                break;
            case 'analyzed':
                counts.analyzed_count++;
                break;
            case 'rejected':
                counts.rejected_count++;
                break;
            case 'interview':
                counts.interview_count++;
                break;
            case 'interesting':
                counts.interesting_count++;
                break;
            case 'retained':
                counts.retained_count++;
                break;
            case 'converted':
                counts.converted_Count++;
                break;
            default:
                break;
            }
        });
        return counts;
    };

    useEffect(()=>{
        if(statusCandiaturesByCompanyId && Array.isArray(statusCandiaturesByCompanyId) ){
            var filteredData = statusCandiaturesByCompanyId;

            if(filtreClient){
                if (selectedClient3 != 'all') {
                    filteredData = statusCandiaturesByCompanyId.filter(
                        (item) => item.companyDataId == selectedClient3
                    );
                }
            }
            if (filtreSourceMission != 'all') {
                filteredData = filteredData.filter(
                    (item) => item.sourceCandidature == filtreSourceMission
                );
            }

            filteredData=filtreListPeriode(filteredData,selectedPeriod3,customDateRange3);

            let CountsListStatusCandidatures=calculateCounts(filteredData);

            CountsListStatusCandidatures=Object.values(CountsListStatusCandidatures);

            setChartDataStatusCandidature((prevState) => {
                return {
                    ...prevState,

                    series: CountsListStatusCandidatures,
                    options:{
                        ...prevState.options,
                        labels:[i18n.t('Lue'),i18n.t('Intéressante'),i18n.t('À interviewer'),i18n.t('Non Retenue'),i18n.t('Retenue'),i18n.t('Non lue'),i18n.t('Mission confirmée')],
                        plotOptions: {
                            ...prevState.options.plotOptions,
                            pie: {
                                ...prevState.options.plotOptions.pie,
                                dataLabels: {
                                    ...prevState.options.plotOptions.pie.dataLabels,
                                    offset: -15, // Adjust the offset to vertically center the labels
                                    formatter: function (val, opts) {
                                        return opts.w.config.series[opts.seriesIndex];
                                    },
                                },
                            },
                        },
                    }
                };
            });
        }
    },[statusCandiaturesByCompanyId,filtreSourceMission,selectedPeriod3,customDateRange3,selectedClient3]);

    return (
        <>
            <div
                className='graph1'
                style={{width:width,height:height}}
            >
                <h1 className='dashFrame5'>{i18n.t('Statut candidatures')}</h1>
                <div className='filtre1'>
                    <div style={{width:'30%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriod3}
                            setSelectedPeriod={setSelectedPeriod3}
                            setCustomDateRange={setCustomDateRange3}
                            listeVal={PeriodeDashboard}

                        />
                    </div>
                    {filtreClient &&
                        <div style={{width:'40%'}}>
                            <SelectUser
                                selectedClientvalue={selectedClient3}
                                setSelectedClientvalue={setSelectedClient3}
                                hideAllClient={false}
                            />
                        </div>
                    }
                    <div style={{width:'20%'}}>
                        <SelectComponent
                            label={i18n.t('Source')}
                            val={filtreSourceMission}
                            name='statusAoCandidatures'
                            setVal={(event)=>{
                                setFiltreSourceMission(event.target.value);
                            }}
                            listVal={sourceMission}
                        />
                    </div>

                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartDataStatusCandidature.options}
                        series={chartDataStatusCandidature.series}
                        type="pie"
                        width={'100%'}
                        height={'85%'}
                    />
                </div>

            </div>
        </>
    );

}
export default StatutCandidatures;